import { writable } from "svelte/store";

const { subscribe, update } = writable({
    coins : 0,
    gems  : 0,

    preview : {
        coins : 0,
        gems  : 0
    },

    // these are used for css
    coinsSuccess : false,
    gemsSuccess  : false
});

export const balance = {
    subscribe,
    updateBalance : ({ type, amount, isPreview }) => {
        update((store) => {
            if (isPreview) {
                store.preview[type] = amount;
            } else {
                store[type] = amount;
            }

            return store;
        });
    }
};
